import { Button } from 'components/ui/button';
import { Table as TableIcon, Code } from 'lucide-react';

interface CreateApiParameterFormHeaderProps {
  title: string;
  description: string;
  viewMode: 'table' | 'json';
  onTableView: () => void;
  onJsonView: () => void;
}

/**
 * Title + Table/JSON toggle for create-api parameter steps. Stacks on small screens
 * so both view buttons stay visible.
 */
export function CreateApiParameterFormHeader({
  title,
  description,
  viewMode,
  onTableView,
  onJsonView,
}: CreateApiParameterFormHeaderProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
      <div className="min-w-0">
        <h2 className="text-xl font-semibold sm:text-2xl">{title}</h2>
        <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      </div>
      <div className="flex w-full gap-2 lg:w-auto lg:shrink-0">
        <Button
          type="button"
          variant={viewMode === 'table' ? 'default' : 'outline'}
          size="sm"
          className="min-h-9 flex-1 lg:flex-none"
          onClick={onTableView}
        >
          <TableIcon className="mr-2 h-4 w-4 shrink-0" />
          Table View
        </Button>
        <Button
          type="button"
          variant={viewMode === 'json' ? 'default' : 'outline'}
          size="sm"
          className="min-h-9 flex-1 lg:flex-none"
          onClick={onJsonView}
        >
          <Code className="mr-2 h-4 w-4 shrink-0" />
          JSON View
        </Button>
      </div>
    </div>
  );
}
